import type { CurvePath, Vector3 } from '@anov/3d-core'

export { RoundedCornersCurve, createRoundedCornersCurve } from './RoundedCornersCurve'

interface RoundedCornersCurveCore {
  /**
   * 圆滑率
   */
  radius: number

  /**
   * 是否闭合
   */
  close: boolean
}

export type RoundedCornersCurveInterface = RoundedCornersCurveCore & CurvePath<Vector3>